import React, { useState } from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import './VintageModal.scss';

export default function RegisterModal({ show, onHide, onSwitchToLogin }) {
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [role, setRole] = useState('student');
  const [bio, setBio] = useState('');
  const [plz, setPlz] = useState('');
  const [ort, setOrt] = useState('');
  const [strasseHausnummer, setStrasseHausnummer] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!name || !email || !password || !confirm || !role) return setError('Bitte füllen Sie alle Felder aus.');
    if (!strasseHausnummer || !plz || !ort) return setError('Bitte geben Sie Ihre vollständige Adresse an.');
    if (password !== confirm) return setError('Die Passwörter stimmen nicht überein.');
    if (password.length < 6) return setError('Das Passwort muss mindestens 6 Zeichen lang sein.');
    
    const parsedPlz = parseInt(plz, 10);
    if (isNaN(parsedPlz)) return setError('Die Postleitzahl muss eine Zahl sein.');

    setLoading(true);
    try {
      await register(name, email, password, role, bio, { plz: parsedPlz, ort, strasseHausnummer });
      onHide();
    } catch (err) {
      setError(err.message || 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="vintage-modal">
      <Modal.Header closeButton>
        <Modal.Title>Konto erstellen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Vollständiger Name</Form.Label>
            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>E-Mail-Adresse</Form.Label>
            <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Ich bin...</Form.Label>
            <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="student">Student (ich suche Hilfe)</option>
              <option value="dozent">Dozent (ich biete Hilfe an)</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Straße & Hausnummer</Form.Label>
            <Form.Control type="text" value={strasseHausnummer} onChange={(e) => setStrasseHausnummer(e.target.value)} required />
          </Form.Group>
          <div className="row">
            <div className="col-5">
              <Form.Group className="mb-3">
                <Form.Label>PLZ</Form.Label>
                <Form.Control type="text" value={plz} onChange={(e) => setPlz(e.target.value)} required />
              </Form.Group>
            </div>
            <div className="col-7">
              <Form.Group className="mb-3">
                <Form.Label>Ort</Form.Label>
                <Form.Control type="text" value={ort} onChange={(e) => setOrt(e.target.value)} required />
              </Form.Group>
            </div>
          </div>
          <Form.Group className="mb-3">
            <Form.Label>Passwort</Form.Label>
            <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Passwort bestätigen</Form.Label>
            <Form.Control type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          </Form.Group>
          {role === 'dozent' && (
            <Form.Group className="mb-3">
              <Form.Label>Kurzbiografie (Optional)</Form.Label>
              <Form.Control as="textarea" rows={2} value={bio} onChange={(e) => setBio(e.target.value)} />
            </Form.Group>
          )}
          <Button type="submit" className="form-button" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Konto erstellen'}
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <span>
          Sie haben bereits ein Konto?{' '}
          <Button variant="link" onClick={onSwitchToLogin}>
            Anmelden
          </Button>
        </span>
      </Modal.Footer>
    </Modal>
  );
}
